import { mapGetters } from "vuex";

export default {
  name: "ActionButton",
  components: {},
  props: ["title", "disabled", "className"],
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["loading"])
  },
  mounted() {},
  methods: {}
};



// WEBPACK FOOTER //
// ./src/components/ActionButton/component.js